export enum ICRMSourceEnum {
  SFDC_ISEO = 'SFDC_ISEO',
  PD_SOFIA = 'PD_SOFIA',
}
